import React from 'react'
import { AuthProvider } from '@praxis/component-auth'
import { getAppConfig } from '../config/appConfig'
import { externalAppRoutes } from '../routes/ExternalAppRoutes'
import { RouterProvider } from 'react-router-dom'

const ExternalAppLayout = () => {
  const config = getAppConfig()
  const authConfig = config.auth

  return (
    <div>
      <AuthProvider
        clientId={authConfig.clientId}
        authorizationUrl={authConfig.authorizationUrl}
        logoutUrl={authConfig.logoutUrl}
      >
        <RouterProvider router={externalAppRoutes} />
      </AuthProvider>
    </div>
  )
}

export default ExternalAppLayout
